import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String,
    name: String,
    slug: String,
    hasLocal: Boolean
  }

  static targets = ["image", "fallback"]

  connect() {
    // If image is already broken upon connection (browsers sometimes don't fire error if loaded from cache or fast failure)
    if (this.imageTarget.complete && this.imageTarget.naturalHeight === 0) {
      this.handleError()
    }
  }

  error() {
    this.handleError()
  }

  handleError() {
    const retries = parseInt(this.data.get("retries") || "0")
    // Retry flow: 
    // 0: Initial attempt (Local or Domain-based Unavatar) -> Failed
    // 1: Try Unavatar Search Query (Smart Search)
    // 2: Give up -> Show Fallback

    if (retries === 0) {
      // First failure. Try smart search query on Unavatar.
      this.data.set("retries", "1")

      const queryName = this.nameValue || this.slugValue.replace(/-/g, " ")
      this.imageTarget.src = `https://unavatar.io/?q=${encodeURIComponent(queryName)}&fallback=false`

    } else {
      // Final failure. Give up.
      this.imageTarget.style.display = "none"
      this.fallbackTarget.style.display = "flex"
    }
  }
}
